import { render } from "./IndexView.vue?vue&type=template&id=4c151008&scoped=true"
import script from "./IndexView.vue?vue&type=script&lang=js"
export * from "./IndexView.vue?vue&type=script&lang=js"

import "./IndexView.vue?vue&type=style&index=0&id=4c151008&scoped=true&lang=css"

import exportComponent from "D:\\myproject\\my\\dp2\\frontend\\public-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c151008"]])

export default __exports__